var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.paymentMethodsEnabled.includes("pix")
    ? _c("div", { staticClass: "checkout-payment-type-items" }, [
        _c(
          "div",
          {
            staticClass:
              "\n      eu-height_100\n      emd-form-box\n      _border_base\n      _active\n      checkout-payment-type-container\n    ",
            class: {
              "eu-border-color_focus":
                _vm.checkout.accepted_payment_methods.includes("pix"),
            },
          },
          [
            _c("div", { staticClass: "emd-form-box__header" }, [
              _c(
                "label",
                { staticClass: "emd-checkbox", attrs: { for: "pix" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.acceptPixCheckBox,
                        expression: "acceptPixCheckBox",
                      },
                    ],
                    staticClass: "emd-checkbox__input",
                    attrs: {
                      name: "pix",
                      type: "checkbox",
                      id: "pix",
                      "data-testid": "checkbox",
                    },
                    domProps: {
                      checked: _vm.acceptPixCheckBox,
                      checked: Array.isArray(_vm.acceptPixCheckBox)
                        ? _vm._i(_vm.acceptPixCheckBox, null) > -1
                        : _vm.acceptPixCheckBox,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updatePaymentMethod("pix")
                      },
                      change: function ($event) {
                        var $$a = _vm.acceptPixCheckBox,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.acceptPixCheckBox = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.acceptPixCheckBox = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.acceptPixCheckBox = $$c
                        }
                      },
                    },
                  }),
                  _c("div", { staticClass: "emd-checkbox__area" }),
                  _c("i", {
                    staticClass:
                      "emd-form-box__image uil uil-icon-2x uil-qrcode-scan",
                    class: {
                      "emd-text _color_tertiary":
                        _vm.checkout.accepted_payment_methods.includes("pix"),
                    },
                    attrs: { "data-testid": "icon" },
                  }),
                  _c("span", { staticClass: "emd-checkbox__text" }, [
                    _vm._v(" " + _vm._s(_vm.$t("checkout.pix.title")) + " "),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "emd-form-box__content" }, [
              _c("div", { staticClass: "emd-form-group" }, [
                _c("label", { staticClass: "emd-label" }, [
                  _vm._v(_vm._s(_vm.$t("checkout.pix.due_date"))),
                ]),
                _c("div", { staticClass: "emd-input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.pixExpirationDate,
                        expression: "pixExpirationDate",
                      },
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##/##/####",
                        expression: "'##/##/####'",
                      },
                    ],
                    staticClass: "emd-input",
                    class: { _state_error: _vm.pixFeedbackError },
                    attrs: {
                      type: "text",
                      placeholder: "dd/mm/aaaa",
                      disabled: !_vm.acceptPixCheckBox,
                      "data-testid": "input",
                    },
                    domProps: { value: _vm.pixExpirationDate },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.pixExpirationDate = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("p", { staticClass: "emd-input-feedback" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("checkout.pix.expires_at", {
                          date: _vm.buildCheckoutExpirationDate(),
                        })
                      ) +
                      " "
                  ),
                ]),
                _vm.pixFeedbackError
                  ? _c(
                      "p",
                      { staticClass: "emd-input-feedback _state_error" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("Data deve ser válida")) + " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }